import { Box, Button } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";

import Context from "../../../context";

// ----------------------------------------------------------------------

export const MobileBtn = () => {
	const { actions } = useContext(Context);
	const { translate } = useLocales();

	return (
		<Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
			<Button variant='contained' size='medium' onClick={() => actions.setStep(1)}>
				{translate("info_panel.connect_my_account")}
			</Button>
		</Box>
	);
};

export default MobileBtn;
